import React from 'react';
import styles from './ToggleSwitch.module.css';

const DEFAULT_COLORS = {
	checkedBackground: 'rgba(42, 250, 0, 0.99)',
	checkedBorderColor: 'rgba(0, 109, 106, 0.99)',
	checkedThumbColor: '#f7fffe',
	focusOutlineColor: 'rgba(255, 214, 165, 0.55)',
};

export default function ToggleSwitch({
	label,
	checked,
	onChange,
	ariaLabel,
	colors = {},
}) {
	const theme = { ...DEFAULT_COLORS, ...colors };

	const switchStyle = {
		'--toggle-checked-bg': theme.checkedBackground,
		'--toggle-checked-border': theme.checkedBorderColor,
		'--toggle-checked-thumb': theme.checkedThumbColor,
		'--toggle-focus-outline': theme.focusOutlineColor,
	};

	return (
		<label className={styles.switch} style={switchStyle}>
			<span className={styles.label}>{label}</span>

			<input
				type="checkbox"
				className={styles.input}
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				aria-label={ariaLabel ?? label}
			/>

			<span className={styles.track} aria-hidden="true">
				<span className={styles.thumb} />
			</span>
		</label>
	);
}
